<template>
  <div>
    <v-dialog v-model="hasActiveItem" max-width="500px">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>View Inventory Details</v-toolbar-title>
        </v-toolbar>
        <v-simple-table class="dialog-no-footer">
          <template v-slot:default>
            <tbody>
              <tr v-for="header in itemHeaders" :key="header.value">
                <td>{{ header.text }}</td>
                <td>{{ activeItem[header.value] }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showHistory">
      <InventoryHistory :id="historyItem.id" v-if="showHistory" />
    </v-dialog>

    <AddInventory :method="getListItems" />

    <!-- Edit Inventory -->
    <v-dialog v-model="hasEditItem" max-width="500px">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="editclose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Details</v-toolbar-title>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-container>
              <!-- <div class="red--text">{{ msg }}</div> -->
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="editid"
                    label="Inventory Id"
                    required
                    dense
                    :rules="[rules.required]"
                    type="number"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.name"
                    label="Enter Name"
                    required
                    dense
                    :rules="[rules.required]"
                    type="text"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.count"
                    label="Enter count"
                    required
                    dense
                    :rules="[rules.required]"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    outlined
                    class="my-5"
                    label="Enter Description"
                    v-model="formData.note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="editclose"
                >Cancel</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="editsave"
                :loading="sending"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Count Plus Inventory -->
    <v-dialog v-model="hasCountItem" max-width="500px">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="countclose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Details</v-toolbar-title>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-container>
              <!-- <div class="red--text">{{ msg }}</div> -->
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="countid"
                    label="Inventory Id"
                    required
                    dense
                    :rules="[rules.required]"
                    type="number"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.name"
                    label="Enter Name"
                    required
                    dense
                    :rules="[rules.required]"
                    type="text"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="formData.count"
                    label="Enter count"
                    required
                    dense
                    :rules="[rules.required]"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    outlined
                    class="my-5"
                    label="Enter Description"
                    v-model="formData.note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="countclose"
                >Cancel</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="countsave"
                :loading="sending"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-btn text @click="viewItem(item)" class="mr-1">
            <v-icon small>remove_red_eye</v-icon> View
          </v-btn>
          <v-btn text @click="viewItemHistory(item)" class="mr-1">
            <v-icon small>history</v-icon> View
          </v-btn>
          <v-btn text @click="editItem(item)" class="mr-1">
            <v-icon small>edit</v-icon>Update
          </v-btn>
          <v-btn text @click="countItem(item)" class="mr-1">
            <v-icon small>library_add</v-icon>Add
          </v-btn>
          <v-btn text @click="deleteItem(item)" color="red">
            <v-icon small>delete</v-icon> Delete
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { inventory as api } from "@/api";
import AddInventory from "@/components/inventory/AddInventory.vue";
import InventoryHistory from "@/components/inventory/InventoryHistory.vue";

export default {
  name: "List",
  components: {
    AddInventory,
    InventoryHistory,
  },
  data: () => ({
    loading: false,
    dialog: false,
    valid: true,
    name: "",
    editid: "",
    countid: "",
    count: "",
    formData: {
      name: "",
      count: "",
      note: "",
    },
    hasActiveItem: false,
    hasEditItem: false,
    hasCountItem: false,
    options: {},
    rules: {
      required: (v) => !!v || "Field is required",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    },
    headers: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Item Name", value: "item_name" },
      { text: "Item Count", value: "item_count" },
      { text: "Actions", value: "action", sortable: false },
    ],
    itemHeaders: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Item Name", value: "item_name" },
      { text: "Item Count", value: "item_count" },
    ],
    itemEditHeaders: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Item Name", value: "item_name" },
      { text: "Item Count", value: "item_count" },
    ],
    listItems: [],
    sending: false,
    totalItems: 0,
    search: "",
    formTitle: "Send Link",
    activeItem: [],
    activeEdit: null,
    countdata: null,
    showHistory: false,
    historyItem: {},
  }),
  watch: {
    options: {
      handler() {
        this.getListItems();
      },
      deep: true,
    },
  },
  computed: {
    // hasActiveItem() {
    //   return Boolean(this.activeItem);
    // },
    // hasEditItem() {
    //   return Boolean(this.activeEdit);
    // },
    // hasCountItem() {
    //   return Boolean(this.countdata);
    // },
  },
  methods: {
    initialize() {
      this.getListItems();
    },
    close() {
      this.hasActiveItem = false;
      // this.listItems = "";
    },

    editclose() {
      this.hasEditItem = false;
      this.activeEdit = "";
    },

    countclose() {
      this.hasCountItem = false;
      this.countdata = "";
    },

    async getListItems() {
      const { page = 1, itemsPerPage = 10 } = this.options;
      this.loading = true;
      const response = await api.getListItems(itemsPerPage, page);
      this.totalItems = response.data.count;
      this.listItems = response.data.data;
      this.loading = false;
    },
    async viewItem(item) {
      this.hasActiveItem = true;
      try {
        // console.log(item.item_name);
        const response = await api.getItem(item.id);
        this.activeItem = response.data[0];
        //  console.log(this.activeItem);
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },
    async viewItemHistory(item) {
      this.showHistory = true;
      this.historyItem = item;
      // console.log(this.historyItem);
    },
    async editItem(item) {
      this.hasEditItem = true;
      try {
        // console.log(item.item_name);
        const response = await api.getItem(item.id);
        this.activeEdit = response.data;
        this.formData.name = this.activeEdit[0]["item_name"];
        this.formData.count = this.activeEdit[0]["item_count"];
        this.formData.note = "";
        this.editid = this.activeEdit[0]["id"];
        // console.log(this.activeEdit);
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },

    async editsave() {
      if (this.$refs.form.validate()) {
        try {
          this.sending = true;
          //    console.log(this.name, this.count);
          await api.editItem(this.editid, this.formData);
          this.sending = false;
          this.$toast.success("Data Edit Successfully");
          this.getListItems();
          this.editclose();
          this.$refs.form.reset();
        } catch (error) {
          this.sending = false;
          alert("Please write Correct data");
          this.close();
          this.$refs.form.reset();
        }
      }
    },

    async countItem(item) {
      this.hasCountItem = true;
      try {
        // console.log(item.item_name);
        const response = await api.getItem(item.id);
        this.countdata = response.data;
        this.formData.name = this.countdata[0]["item_name"];
        this.formData.count = "";
        this.formData.note = "";
        this.countid = this.countdata[0]["id"];
        // console.log(this.activeEdit);
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },

    async countsave() {
      if (this.$refs.form.validate()) {
        try {
          this.sending = true;
          //    console.log(this.name, this.count);
          await api.countInventory(
            this.countid,
            this.formData.count,
            this.formData.note
          );
          this.sending = false;
          this.$toast.success("Data Edit Successfully");
          this.getListItems();
          // this.hasCountItem = false;
          this.countclose();
        } catch (error) {
          this.sending = false;
          this.$toast.success("Data not Sent");
          this.close();
        }
      }
    },

    closeItem() {
      this.activeItem = null;
    },
    async deleteItem(item) {
      // console.log(item);
      const confirm = await this.$alert.confirm(
        `Delete Inventory Data #${item.item_name} ?`
      );
      if (confirm && confirm.value === true) {
        try {
          await api.deleteItem([item.id]);
          this.$toast.success("Deleted Successfully");
          this.getListItems();
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
    },
  },
};
</script>